var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-list',{attrs:{"value":"expenses","text":"開支","shopOptions":_vm.shopOptions,"selectShop":true,"fields":_vm.fields,"items":_vm.expenseByShop},on:{"updateShop":_vm.getShop}})}
var staticRenderFns = []

export { render, staticRenderFns }